"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.run_bomb = void 0;
var rando_sidecar_1 = require("@lib/rando-sidecar");
var voyageMessageCrewCarry_sidecar_1 = require("@voyage/multi/voyageMessageCrewCarry-sidecar");
var voyageMessageEffectCommand_1 = require("@voyage/multi/voyageMessageEffectCommand");
var voyageMessageEffectCommand_sidecar_1 = require("@voyage/multi/voyageMessageEffectCommand-sidecar");
var voyageCarryableData_1 = require("@voyage/entities/voyageCarryableData");
var voyageTilemap_sidecar_1 = require("../tilemap/voyageTilemap-sidecar");
function run_bomb(min, max) {
    var num = rando_sidecar_1.rando.i(min, max);
    for (var i = 0; i < num; i++) {
        setTimeout(function () {
            var fl = voyageTilemap_sidecar_1.voyageTilemap.getRandomFloor();
            var type = rando_sidecar_1.rando.sample([
                voyageCarryableData_1.EVoyageCarryableType.Breachbomb,
                voyageCarryableData_1.EVoyageCarryableType.Firebomb,
            ]);
            voyageMessageCrewCarry_sidecar_1.voyageMessageCrewCarry.sendCreateMessageAndImmediatelyExecute({
                i: fl.i,
                j: fl.j,
                type: type,
            });
            voyageMessageEffectCommand_sidecar_1.voyageMessageEffectCommand.sendMessageAndImmediatelyExecute({
                command: voyageMessageEffectCommand_1.EEffectCommand.HitParticles,
                x: fl.x,
                y: fl.y,
            });
        }, 1000 * i);
        // let entrance = voyageTilemap.getRandomLanding()
        // diveCrew.moveToIJ()
    }
}
exports.run_bomb = run_bomb;
